<!-- role="status" + aria-live: the bar announced nothing to a screen reader
     before. "polite" because this is a nudge, not an emergency. -->
<div class="top-banner" role="status" aria-live="polite">
  <span class="banner-pulse" aria-hidden="true"></span>

  <!-- Message only. Showing the title too read as a stutter — "✅ New operation
       has started — New operation has started. Please create your parcel list" —
       and wrapped the bar onto a second line. `message` is the one-liner; the
       title still rides the bell and the browser notification. -->
  <span class="banner-message">{{ notification.message }}</span>

  <!-- The action sits next to the sentence that asks for it, rather than pinned
       to the far edge with a lake of empty bar between them. -->
  @if (notification.ctaUrl) {
    <button type="button" (click)="goToAction()" class="banner-cta">
      <span>{{ notification.ctaText ?? 'Open' }}</span>
      <span class="fe fe-arrow-right" aria-hidden="true"></span>
    </button>
  }

  <span class="banner-trailing">
    @if (queuedCount() > 0) {
      <span class="banner-more">+{{ queuedCount() }} more</span>
    }
    <button
      type="button"
      (click)="dismiss()"
      class="banner-dismiss"
      aria-label="Dismiss this announcement"
    >
      <span class="fe fe-x" aria-hidden="true"></span>
    </button>
  </span>
</div>
